export const Marquee = ({ items, dark = true }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? "bg-ink text-paper border-white/10" : "bg-paper text-ink border-ink/10"}`}
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap py-4">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-display text-sm sm:text-base font-medium uppercase tracking-[0.3em]">
            <span className="px-6">{item}</span>
            <span className="text-pink">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
